import HideOnMobile from '@anm/components/mobile/HideOnMobile';
import { flexCenter } from '@anm/styles/helpers';
import styled from 'styled-components';

export const RatioList = styled.ul``;

export const ImageRatioContainer = styled.div`
  ${flexCenter};
  min-height: 34px;
`;

export const VideoRatioListWrapper = styled(HideOnMobile)`
  pointer-events: all;
  ${RatioList} {
    ${flexCenter};
    flex-wrap: wrap;
    position: relative;
    z-index: 123;
  }
`;
